export default __webpack_public_path__ + "static/media/ic-male.10b90380.svg";